import React from 'react';
import { useHistory } from 'react-router-dom';
import { ModalBody } from 'reactstrap';

import lang from '../../lib/language';

import BaseModal from '../BaseModal/BaseModal';
import { ButtonTypesEnum } from '../Button/Button.types';
import { Button } from '../index';

import styles from './NotEnoughBuyingPower.module.scss';

type Props = {
  closeModal: () => void;
};

const NotEnoughBuyingPower = ({ closeModal }: Props) => {
  const history = useHistory();

  return (
    <BaseModal isOpen>
      <h6 className={styles.header}>{lang.commonTradingNotEnoughBuyingPowerTitle()}</h6>
      <ModalBody>
        <p className={styles.text}>{lang.commonTradingNotEnoughBuyingPowerDescription()}</p>
        <div className={styles.actions}>
          <Button
            variant={ButtonTypesEnum.Primary}
            fullWidth
            className={styles.btnCancel}
            onClick={() => closeModal()}
          >
            {lang.commonGood() }
          </Button>
        </div>
      </ModalBody>
    </BaseModal>
  );
};

export default NotEnoughBuyingPower;
